import * as types from "./types.js"
import * as api from "./api.js"


function getLanguagesRequest() {
    return {
        type: types.GET_LANGUAGES_REQUEST
    }
}

function getLanguagesReceived(languages) {
    return {
        type: types.GET_LANGUAGES_RECEIVED,
        payload: languages
    }
}

function getLanguagesError(e) {
    return {
        type: types.GET_LANGUAGES_ERROR,
        payload: e,
        error: true
    }
}

export function getLanguages(personid) {
    return dispatch => {
        dispatch(getLanguagesRequest())
        return api.getLanguages(personid)
        .then(res => {
            if (res.status !== 200) {
                dispatch(getLanguagesError(res.statusText))
            } else {
                return res.json()
                .then(languages => {
                    dispatch(getLanguagesReceived(languages))
                })
            }
        })
    }
}


function postLanguageRequest() {
    return {
        type: types.POST_LANGUAGE_REQUEST
    }
}

function postLanguageReceived(language) {
    return {
        type: types.POST_LANGUAGE_RECEIVED,
        payload: language
    }
}

function postLanguageError(e) {
    return {
        type: types.POST_LANGUAGE_ERROR,
        payload: e,
        error: true
    }
}

export function postLanguage(language) {
    return dispatch => {
        dispatch(postLanguageRequest())
        return api.postLanguage(language)
        .then(res => {
            if (res.status !== 200) {
                dispatch(postLanguageError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(postLanguageReceived({
                        id: stats.id,
                        language: language.language,
                        code: language.code,
                        level: language.level
                    }))
                })
            }
        })
    }
}

function deleteLanguageRequest() {
    return {
        type: types.DELETE_LANGUAGE_REQUEST
    }
}

function deleteLanguageReceived(language) {
    return {
        type: types.DELETE_LANGUAGE_RECEIVED,
        payload: language
    }
}

function deleteLanguageError(e) {
    return {
        type: types.DELETE_LANGUAGE_ERROR,
        payload: e,
        error: true
    }
}

export function deleteLanguage(id) {
    return dispatch => {
        dispatch(deleteLanguageRequest())
        return api.deleteLanguage(id)
        .then(res => {
            if (res.status !== 200) {
                dispatch(deleteLanguageError(res.statusText))
            } else {
                return res.json()
                .then(stats => {
                    dispatch(deleteLanguageReceived({ id }))
                })
            }
        })
    }
}


/** WEBPACK FOOTER **
 ** ./src/actions/profile/languages/actions.js
 **/